import React, { useContext } from 'react';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';

import "./snackbar-style.scss";
import { useSnackbar } from '@src/providers/SnackbarProvider';
import { DeviceContext, deviceType } from '@providers';

import Button from '@src/componentsNew/Buttons/Button';
import CloseIcon from '@src/componentsNew/Icons/Icons/CloseIcon';

const Transition = React.forwardRef<unknown, any>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomSnackBar = () => {
  const { snackbarProps } = useSnackbar();
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    <Snackbar
      id='custom-snack-bar'
      className={isMobile ? "mobile" : "desktop"}
      message={snackbarProps?.message}
      open={snackbarProps?.open}
      onClose={snackbarProps?.onClose}
      onClick={(e) => e.stopPropagation()}
      autoHideDuration={snackbarProps?.autoHideDuration}
      TransitionComponent={Transition}
      action={
        <>
          {snackbarProps?.isShowBtn && (
            <Button
              style={{ color: '#EF6BFF' }}
              size="medium"
              onClick={snackbarProps?.btnOnClick}
            >
              {snackbarProps?.btnContent}
            </Button>
          )}
          {snackbarProps?.isShowCloseBtn && (
            <CloseIcon
              strokeColor='#FFFFFF'
              onClick={(e) => {
                e.stopPropagation();
                snackbarProps?.onClose();
              }}
            />
          )}
        </>
      }
    />
  );
};

export default CustomSnackBar;
